var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.REGION_TOOLBAR.isVisible
    ? _c(
        "b-container",
        { staticClass: "us-region-toolbar-container", style: _vm.style },
        [
          _c(
            "div",
            [
              _c(
                "b-button-toolbar",
                {
                  staticClass: "us-region-toolbar us-color-picker-target",
                  attrs: {
                    "key-nav": "",
                    "aria-label": "Toolbar with button groups"
                  }
                },
                [
                  _vm._l(_vm.toolGroups, function(group, index) {
                    return _c(
                      "b-button-group",
                      { key: index, staticClass: "mx-1" },
                      _vm._l(group, function(tool) {
                        return _vm.toolIsEnabled(tool)
                          ? _c("b-btn", {
                              key: tool,
                              class: "annotation-icon-" + tool,
                              attrs: { title: _vm.$t("tooltips." + tool) },
                              on: {
                                click: function($event) {
                                  return _vm.onToolClick(tool, $event)
                                }
                              }
                            })
                          : _vm._e()
                      }),
                      1
                    )
                  }),
                  _vm._v(" "),
                  _vm.addOns.length > 0
                    ? _c(
                        "b-button-group",
                        _vm._l(_vm.addOns, function(addOn) {
                          return _c(addOn.button, {
                            key: addOn.key,
                            tag: "component"
                          })
                        }),
                        1
                      )
                    : _vm._e()
                ],
                2
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-container",
            _vm._l(_vm.panels, function(panel) {
              return _c(panel.ui, { key: panel.key, tag: "component" })
            }),
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/uScope/js/extensions/annotations/annotations-ui/RegionToolbar.vue?vue&type=template&id=1aa370c8&scoped=true&
// module id = 391
// module chunks = 0